export function getSuperAdminEmails() {
  const keys = [
    "REACT_APP_SUPER_ADMIN1",
    "REACT_APP_SUPER_ADMIN2",
    "REACT_APP_SUPER_ADMIN3",
    "REACT_APP_SUPER_ADMIN4",
    "REACT_APP_SUPER_ADMIN5",
    // Add more if needed
  ];
  return keys
    .map(key => process.env[key])
    .filter(Boolean)
    .map(email => email.trim().toLowerCase());
}